module.exports = __webpack_public_path__ + "static/img/honor_3.92cf6ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/honor_3.jpg
// module id = 4qtr
// module chunks = 0